import type {MouseEventHandler} from 'react'

export const onOverflowingElementMouseEnter: MouseEventHandler<HTMLDivElement> = e => {
  const target = e.currentTarget as HTMLDivElement
  const overflowTitle = target.getAttribute('data-overflow-title')

  if (overflowTitle != null) {
    if (target.clientWidth < target.scrollWidth) {
      target.setAttribute('title', overflowTitle)
    }
    target.removeAttribute('data-overflow-title')
  }
}
